import React from "react";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core";
import TitleText from "../../components/TitleText";
import DropField from "./DropField";
import Semester from "./Semester";
import {
  IconHome,
  IconTag,
  IconCheckIn,
  IconTrolley
} from "../../components/Icon";
import Calendar from "react-calendar";
const styles = theme => ({
  buttonsWrapper: {
    padding: theme.spacing(4)
  }
});

const SemesterForm = ({
  classes,
  selectedSemesters,
  semesterList,
  onSemesterChange,
  onChangeStartingDate,
  onChangeEndDate,
  start_at,
  end_at
}) => {
  
  start_at = Object.keys(start_at).length ? start_at.toDate() : start_at
  end_at = Object.keys(end_at).length ? end_at.toDate() : end_at
  
  return (
    <div className="semester">
      <div className="semester__title">
        <TitleText>Semesters</TitleText>
      </div>
      {/* <span className="semester__description">
        Lorem ipsum dolor sit amet, consectetur adipiscing
        <br /> elit, sed do eiusmod tempor
      </span> */}
      {/* <Grid
        container
        direction="row"
        justify="center"
        className="semester__semesters"
      >
        {selectedSemesters.map((semester, index) => {
          return (
            <DropField
              key={index}
              selected={semesterList}
              list={semesterList}
              index={index}
              onRemove={() => onSemesterChange(null, index)}
              onDrop={item => onSemesterChange(item.semester, index)}
            >
              {semester && (
                <>
                  <h2>{semester.name}</h2>
                  <p>
                    {semester.start_at.toDate().toLocaleDateString(undefined, {day: '2-digit', month: '2-digit', year: 'numeric'})} -{" "}
                    {semester.end_at.toDate().toLocaleDateString(undefined, {day: '2-digit', month: '2-digit', year: 'numeric'})}
                  </p>
                </>
              )}
            </DropField>
          );
        })}
      </Grid>
      <Grid
        container
        direction="row"
        justify="space-between"
        className="semester__semesterlist"
      >
        {semesterList.map((semester, index) => (
          // <DropField key={index}>
          <Semester key={index} semester={semester} />
          // </DropField>
        ))}
      </Grid> */}
      <Grid className="calendars">
        <div className="calendars__cal">
          <div className="calendarTitle">
            <IconCheckIn className="calendarTitle__icon" />
            <span className="calendarTitle__text">Start date</span>
          </div>
          <Calendar
            calendarType="US"
            className="calendar"
            onChange={onChangeStartingDate}
            value={start_at}
          />
        </div>
        <div className="calendars__cal">
          <div className="calendarTitle">
            <IconTrolley className="calendarTitle__icon" />
            <span className="calendarTitle__text">Finish date</span>
          </div>
          {/* <SemesterCalendar selected_date={end_date} /> */}
          <Calendar
            calendarType="US"
            className="calendar"
            onChange={onChangeEndDate}
            value={end_at}
          />
        </div>
      </Grid>
      <Grid className="daysGrid">
        <span className="daysNumber">
          {Math.round(
            Math.abs(
              start_at - end_at
            ) / 8.64e7
          )}
        </span>
        <span className="daysText">
          days of <br />
          awesomeness
        </span>
        {/* <div className="circles" /> */}
      </Grid>
    </div>
  );
};

export default withStyles(styles)(SemesterForm);
